import util from '@/util'
import infra from '@/util/infra'
import mensagens from '@/util/mensagens'

const infraMixin = {
  methods: {
    obterListaPerfisAcessoDiretoJuridico () {
      const envPerfilAcessoDiretoJuridico = process.env.VUE_APP_PERFIL_ACESSO_DIRETO_JURIDICO
      if (util.valorVazio(envPerfilAcessoDiretoJuridico)) {
        return []
      }
      const listaPerfis = envPerfilAcessoDiretoJuridico.split(',')
      return listaPerfis
    },

    async redirecionarParaSistemaExterno (urlSistema, abrirEmNovaJanela = true) {
      try {
        const resposta = await this.axios.get(urlSistema)
        const retorno = resposta.data.retorno
        if (retorno.success === true) {
          const url = retorno.url ?? retorno.url_login
          if (abrirEmNovaJanela) {
            window.open(url, '_blank')
          } else {
            window.location.href = url
          }
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', retorno.message)
        }
      } catch (e) {
        const mensagem = e.response.data.retorno.message ?? mensagens.falhaServidorCarregandoDados
        util.criarAlertaToastDeErro(this, 'Aviso', mensagem)
      }
    },

    redirecionarParaManager (rota, callback) {
      this.$router.push({ name: rota }).then(callback)
    },

    redirecionarSeNaoEstiverNaRotaDefault (rota) {
      const nomeRotaDefault = infra.obterNomeRotaDefault()
      if (nomeRotaDefault !== rota) {
        this.$router.push({ name: nomeRotaDefault })
      }
    }
  }
}

export { infraMixin }
